// Si una pantalla falla, en vez de quedar en blanco se muestra un aviso con opciones, y el
// error se reporta al equipo.
import { Component, type ReactNode } from 'react';
import { isStaleChunkError, reportError } from '../lib/errorReporter';
import { t } from '../lib/i18n';

const RELOAD_KEY = 'app.reloadedForUpdate';

export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    // Se publicó una versión nueva mientras la pantalla estaba abierta: se recarga sola, pero
    // como mucho una vez por minuto (si el archivo de verdad falta, no se queda recargando).
    if (isStaleChunkError(error)) {
      let last = 0;
      try { last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0); sessionStorage.setItem(RELOAD_KEY, String(Date.now())); } catch { /* sin almacenamiento */ }
      if (Date.now() - last > 60_000) { window.location.reload(); return; }
    }
    reportError(error, { componentStack: info.componentStack });
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="center-page">
        <div className="card" style={{ maxWidth: 460, width: '100%' }}>
          <div className="card-body stack">
            <h1 style={{ margin: 0 }}>{t('Algo salió mal en esta pantalla')}</h1>
            <p className="muted" style={{ margin: 0 }}>{t('El equipo ya recibió el aviso. Puedes recargar la página o volver al inicio; lo que ya guardaste no se perdió.')}</p>
            <div className="row">
              <button className="btn btn-primary" onClick={() => window.location.reload()}>{t('Recargar')}</button>
              <a className="btn btn-secondary" href="/">{t('Ir al inicio')}</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
